import React from 'react'

const DisplayValue = (props) => {
    const { label, value, showNull, defaultNullValue } = props
    const isEmpty = value === null || value === undefined || value === ''

    if (isEmpty && !showNull) {
        return null
    }

    return (
        <div className={`display-value ${props.extraClass ? props.extraClass : ''}`}>
            <span className="label">
                {label}
            </span>
            <span className="value">
                {!isEmpty
                    ? <>{value}</>
                    : <>{defaultNullValue ? defaultNullValue : '--'}</>
                }
            </span>
        </div>
    )
}

export default DisplayValue
